import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#1c1c1e',
      paddingTop: '2rem',
      paddingBottom: '2rem'
    }}>
      <Container style={{ maxWidth: '800px' }}>
        <div className="text-center mb-4">
          <Link to="/welcome" style={{ textDecoration: 'none' }}>
            <h2 style={{ color: 'white' }}>
              <span role="img" aria-label="logo">📊</span> EchoBrief
            </h2>
          </Link>
        </div>
        
        <Card style={{ backgroundColor: 'rgba(52, 58, 64, 0.9)', border: 'none' }}>
          <Card.Body className="p-4 p-md-5">
            <h1 className="text-white mb-4">Terms of Service</h1>
            <p className="text-white-50 mb-4">Last updated: January 2025</p>
            
            <div className="text-white-50" style={{ lineHeight: '1.8' }}>
              <h4 className="text-white mt-4 mb-3">1. Acceptance of Terms</h4>
              <p>
                By accessing or using EchoBrief ("Service"), you agree to be bound by these Terms of Service. 
                If you do not agree to these terms, please do not use our Service.
              </p>

              <h4 className="text-white mt-4 mb-3">2. Description of Service</h4>
              <p>
                EchoBrief provides AI-powered meeting transcription, summarization, and insight extraction services. 
                Our Service includes:
              </p>
              <ul>
                <li>Audio and video file transcription using AI technology</li>
                <li>Meeting summary generation</li>
                <li>Action item extraction</li>
                <li>Document analysis</li>
                <li>Integration with third-party services</li>
              </ul>

              <h4 className="text-white mt-4 mb-3">3. User Accounts</h4>
              <p>
                To use certain features of the Service, you must create an account. You are responsible for:
              </p>
              <ul>
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Notifying us immediately of any unauthorized use</li>
              </ul>

              <h4 className="text-white mt-4 mb-3">4. Acceptable Use</h4>
              <p>You agree not to:</p>
              <ul>
                <li>Upload content that violates any laws or third-party rights</li>
                <li>Use the Service for any illegal or unauthorized purpose</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with or disrupt the Service</li>
                <li>Upload malicious code or content</li>
              </ul>

              <h4 className="text-white mt-4 mb-3">5. Content Ownership</h4>
              <p>
                You retain ownership of all content you upload to EchoBrief. By uploading content, 
                you grant us a limited license to process your content for the purpose of providing our Service.
                We do not use your content to train AI models.
              </p>

              <h4 className="text-white mt-4 mb-3">6. Payment Terms</h4>
              <p>
                Paid subscriptions are billed in advance on a monthly or annual basis. 
                Refunds are handled on a case-by-case basis. You may cancel your subscription at any time, 
                and you will retain access until the end of your billing period.
              </p>

              <h4 className="text-white mt-4 mb-3">7. Limitation of Liability</h4>
              <p>
                EchoBrief is provided "as is" without warranties of any kind. We shall not be liable for 
                any indirect, incidental, special, or consequential damages arising from your use of the Service.
              </p>

              <h4 className="text-white mt-4 mb-3">8. Changes to Terms</h4>
              <p>
                We may update these terms from time to time. We will notify users of significant changes 
                via email or through the Service. Continued use after changes constitutes acceptance of the new terms.
              </p>

              <h4 className="text-white mt-4 mb-3">9. Contact</h4>
              <p>
                For questions about these Terms, please contact us at support@echobrief.com.
              </p>
            </div>
            
            <div className="mt-5 text-center">
              <Link to="/welcome" className="btn btn-primary">
                Back to Home
              </Link>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default TermsOfService;
